// src/getChronologicleDay.js

import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase/firebase";
import { calculateDayFromStart, CHRONOLOGICLE_START_DATE } from "./dayCalculation";

// 🧠 Main function to determine today's Chronologicle day number
export const getChronologicleDay = async (testMode = false) => {
  if (testMode) return 1;

  try {
    // ⚡️ NEW: Call Server Function directly
    // This gives us the authoritative Day Number without needing a daily cron job.
    // The server calculates it on-the-fly using its own consistent clock.
    const { httpsCallable } = await import("firebase/functions");
    const { functions } = await import("./firebase/firebase");

    const getGameDay = httpsCallable(functions, 'getGameDay');
    const result = await getGameDay();

    // The function returns { day: N }
    const day = result.data.day;
    console.log("📅 Server says Day:", day);

    return day;

  } catch (err) {
    console.warn("🔥 Failed to fetch server day, trying local fallback...", err);

    // Fallback: Read config locally if function fails (offline, etc)
    const cachedStart = localStorage.getItem("chrono_startDate");
    if (cachedStart) {
      return calculateDayFromStart(cachedStart);
    }

    // Extra fallback: Fetch config doc manually
    try {
      const configRef = doc(db, "config", "gameState");
      const snap = await getDoc(configRef);
      if (snap.exists()) {
        const { startDate } = snap.data();
        localStorage.setItem("chrono_startDate", startDate);
        return calculateDayFromStart(startDate);
      }
    } catch (e) {
      console.warn("Complete failure to get day:", e);
    }

    return 1;
  }
};

// ⚡️ INSTANT SYNC VERSION
// Uses cached start date + client time to guess day immediately
export const getOptimisticDay = () => {
  const cachedStart = localStorage.getItem("chrono_startDate") || CHRONOLOGICLE_START_DATE;
  return calculateDayFromStart(cachedStart);
};
